


































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue } from "vue-property-decorator";
import alatReuseStore from "@/store/modules/AlatReuseStore";
import Service from "@/services/AlatReuseService";
import { TINGKAT_KERUSAKAN, TINDAKAN_KERUSAKAN } from "@/constants/alatReuseOptions";
import { KerusakanAlatReuse, MasterAlatReuse } from "@/types/alat_reuse";

@Component
export default class KerusakanAlatReusePage extends Vue {
  filter: any = {
    tgl_dari: "",
    tgl_sampai: "",
    tindakan: null
  };

  dialog = false;
  deleteDialog = false;
  saving = false;
  editingId: number | null = null;
  toDelete: KerusakanAlatReuse | null = null;
  errors: Record<string, string[]> = {};

  masterOptions: MasterAlatReuse[] = [];
  snackbar = { show: false, color: "success", text: "" };

  tingkatOptions = TINGKAT_KERUSAKAN;
  tindakanOptions = TINDAKAN_KERUSAKAN;

  form: any = this.emptyForm();

  headers = [
    { text: "Tanggal", value: "tanggal_ditemukan", width: 110 },
    { text: "Alat Reuse", value: "alat" },
    { text: "Penggunaan Ke", value: "penggunaan_ke", width: 120, align: "center" },
    { text: "Jenis Kerusakan", value: "jenis_kerusakan" },
    { text: "Tingkat", value: "tingkat_kerusakan", width: 110 },
    { text: "Tindakan", value: "tindakan", width: 150 },
    { text: "", value: "actions", sortable: false, width: 90 }
  ];

  get loading() { return alatReuseStore.loading; }
  get kerusakanList() { return alatReuseStore.kerusakanList; }

  get canSubmit(): boolean {
    return !!(
      this.form.master_alat_reuse_id &&
      this.form.penggunaan_ke &&
      this.form.jenis_kerusakan &&
      this.form.tindakan &&
      this.form.tanggal_ditemukan
    );
  }

  get showDeactivateWarning(): boolean {
    return this.form.tindakan === "tarik" || this.form.tindakan === "musnahkan";
  }

  emptyForm() {
    return {
      master_alat_reuse_id: null,
      kode_unit_alat: "",
      penggunaan_ke: 1,
      jenis_kerusakan: "",
      tingkat_kerusakan: null,
      tindakan: null,
      tanggal_ditemukan: localISODate(),
      catatan: ""
    };
  }

  async mounted() {
    await Promise.all([this.loadData(), this.loadMasterOptions()]);
  }

  async loadData() {
    await alatReuseStore.loadKerusakan({
      tgl_dari: this.filter.tgl_dari || undefined,
      tgl_sampai: this.filter.tgl_sampai || undefined,
      tindakan: this.filter.tindakan || undefined
    });
  }

  async loadMasterOptions() {
    // Include non-active juga — alat yang sudah ditarik pun tetap bisa direferensikan
    const res = await Service.masterList({ params: { per_page: 500 } });
    const d = res.data.data;
    this.masterOptions = d.data || d || [];
  }

  masterItemText(item: MasterAlatReuse) {
    const status = item.aktif ? "" : " [NON-AKTIF]";
    return `${item.kode_alat} — ${item.nama_alat}${status}`;
  }

  async openCreate() {
    this.editingId = null;
    this.form = this.emptyForm();
    this.errors = {};
    if (this.masterOptions.length === 0) await this.loadMasterOptions();
    this.dialog = true;
  }

  openEdit(item: KerusakanAlatReuse) {
    this.editingId = item.id;
    this.form = {
      master_alat_reuse_id: item.master_alat_reuse_id,
      kode_unit_alat: item.kode_unit_alat || "",
      penggunaan_ke: item.penggunaan_ke,
      jenis_kerusakan: item.jenis_kerusakan,
      tingkat_kerusakan: item.tingkat_kerusakan || null,
      tindakan: item.tindakan,
      tanggal_ditemukan: item.tanggal_ditemukan,
      catatan: item.catatan || ""
    };
    this.errors = {};
    this.dialog = true;
  }

  async save() {
    this.saving = true;
    this.errors = {};
    try {
      let resp: any;
      if (this.editingId) {
        resp = await alatReuseStore.updateKerusakan({ id: this.editingId, data: this.form });
      } else {
        resp = await alatReuseStore.createKerusakan(this.form);
      }
      this.dialog = false;

      // Notif kalau master dinonaktifkan oleh backend
      if (resp && resp.master_dinonaktifkan) {
        this.snackbar = {
          show: true,
          color: "warning",
          text: "Master alat telah dinonaktifkan karena tindakan tarik/musnahkan."
        };
      }

      await Promise.all([this.loadData(), this.loadMasterOptions()]);
    } catch (e) {
      const err = e as any;
      if (err && err.response && err.response.data && err.response.data.errors) {
        this.errors = err.response.data.errors;
      }
    } finally {
      this.saving = false;
    }
  }

  confirmDelete(item: KerusakanAlatReuse) {
    this.toDelete = item;
    this.deleteDialog = true;
  }

  async doDelete() {
    if (!this.toDelete) return;
    this.saving = true;
    try {
      await alatReuseStore.deleteKerusakan(this.toDelete.id);
      this.deleteDialog = false;
      this.toDelete = null;
      await this.loadData();
    } finally {
      this.saving = false;
    }
  }

  printPdf() {
    Service.printKerusakanPdf({
      tgl_dari: this.filter.tgl_dari || undefined,
      tgl_sampai: this.filter.tgl_sampai || undefined,
      tindakan: this.filter.tindakan || undefined
    });
  }

  // ---- Formatters ----
  formatDate(s: string) {
    if (!s) return "-";
    const d = new Date(s);
    return d.toLocaleDateString("id-ID");
  }

  tingkatColor(t: string) {
    return { ringan: "amber darken-2", sedang: "orange darken-2", berat: "red darken-2" }[t] || "grey";
  }

  tindakanColor(t: string) {
    return { perbaiki: "blue", tarik: "orange darken-2", musnahkan: "red darken-2" }[t] || "grey";
  }

  tindakanLabel(t: string) {
    const found = this.tindakanOptions.find(o => o.value === t);
    return found ? found.text : t;
  }
}
